module.exports = {
  lg: {
    '店铺': 'shop',
    '商品匹配': 'Product matching',
    '订单': 'orders',
    '操作日志': 'logList',
    '设置': 'set up',
    '物流管理': 'logistics',
    '订单字段映射': 'Order field mapping',
    '参数设置': 'Parameter setting',
    '用户': 'User settings',
    '角色': 'role',
    '时间': 'time',
    '用户创建时间': 'Creation time',
    '是否管理员': 'Administrator or not',
    '待处理': 'Pending',
    '已启用': 'Enabled',
    '权限': 'jurisdiction',
    '退出登录': 'Log out',
    '邀请用户': 'Invite users',

    '取消': 'cancel',
    '失败': 'fail',
    '成功': 'success',
    '请选择': 'Please select',
    '切换语言成功': 'Switch language successfully',
    '请输入': 'Please enter',
    '登录': 'Sign in',
    '邮箱': 'mailbox',
    '邮件地址': 'mailing address',
    '请输入邮件地址': 'Please enter email address',
    '密码': 'password',
    '请输密码': 'Please enter the password',
    '忘记密码': 'Forget password',
    '无账号': 'No account',
    '创建新的': 'Create new',
    '发送': 'send out',
    '发送成功': 'Sent successfully',
    '使用条款': 'Terms of use',
    '隐私政策': 'Privacy policy',
    '重置您的密码': 'Reset your password',
    '确认密码': 'Confirm password',
    '确定': 'determine',
    '您的完整名称': 'Your full name',
    '我接受': 'I accept',
    '和': 'and',
    '创建您的账户': 'Create your account',
    '注册': 'register',
    '去登录': 'Go login',
    '请输入您的完整名称': 'Please enter your full name',
    '注册成功': 'login was successful',
    '请输入密码': 'Please input a password',
    '请输入确认密码': 'Please enter the confirmation password',
    '创建时间': 'Creation time',
    '绑定时间': 'Binding',
    '开始日期': 'Start',
    '结束日期': 'End',
    '组织名称': 'organization',
    '查询': 'query',
    '绑定': 'binding',
    '查看详情': 'details',
    '查看店铺': 'shop',
    '保存': 'save',
    '详情': 'details',
    '订阅到期日': 'Subscription expiration',
    '订阅订单量': 'Subscription order quantity',
    '已用订单量': 'Used order quantity',
    '剩余订单量': 'Remaining order quantity',
    '店铺详情': 'details',
    '操作': 'operation',
    '店铺名称': 'Store name',
    '平台类型': 'Platform type',
    '状态': 'state',
    'DEAR承运人': 'DEAR carrier',
    '确定要禁用吗': 'Are you sure you want to disable it',
    '启用': 'Enable',
    '已启用': 'Opened',
    '是': 'on',
    '否': 'off',
    '开启': 'open',
    '物流平台': 'Logistics platform',
    '物流平台类型': 'Type of logistics platform',
    '所属物流': 'logistics',
    '物流平台ID': 'Logistics platform ID',
    '物流平台类型ID': 'Type of logistics platform ID',
    '所属物流名称': 'Logistics name',
    '是否默认': 'Default',
    '确定要设置为默认吗': 'Are you sure you want to set it as default',
    '提示': 'Tips',
    '商品代码': 'code',
    '未匹配': 'Unmatched',
    '已匹配': 'Matched',
    '下载平台商品': 'Download Product',
    '商品自动匹配': 'Automatic matching',
    '自动匹配tip': 'automatically match according to the "commodity code" field. The matching status of the matched commodity mark is "matched", otherwise it is "unmatched"',

    '保存': 'save',
    '平台产品': 'Platform products',
    '产品代码': 'Product code',
    '产品内码': 'Product internal code',
    '产品名称': 'Product name',
    '规格型号': 'Specifications',
    'DEAR产品': 'DEAR product',
    '导入': 'Import',
    '将文件拖到此处，或': 'Drag files here，or',
    '点击上传': 'Click upload',
    '提示：仅允许导入': 'Tips：Allow import only',
    '下载Excel模板': 'Download excel template',
    '格式文件': 'Format file',
    '请上传文件': 'lease upload the file',
    '操作人': 'Operator',
    '操作时间': 'Operation time',
    '操作描述': 'describe',
    '参考号': 'Reference number',
    '订单附加属性': 'Order additional attributes',
    '平台订单可选字段': 'Optional fields of platform order',
    '类型': 'type',
    '关联': 'relation',
    '买家备注': "Buyer's remarks",
    '卖家备注': "Seller's remarks",
    '买家昵称': 'Buyer nickname',
    '附加属性': 'Additional attributes',
    '下载订单': 'Download order',
    '同步到': 'Sync to',
    '平台订单编号': 'Platform order number',
    '订单下单日期': 'Order placing date',
    '订单付款日期': 'Order payment date',
    '平台订单状态': 'Platform order status',
    '退款状态': 'Refund status',
    '订单金额': 'Order amount',
    '实付金额': 'Paid in amount',
    'DEAR订单编号': 'DEAR number',
    'OMS订单状态': 'OMS order status',
    '订单下载日期': 'Download date',
    '订单详情': 'details',
    '商品名称': 'commodity',
    '数量': 'quantity',
    '总价': 'Total price',
    '已删除': 'Deleted',
    '已关闭': 'Closed',
    '已取消': 'Canceled',
    '未知': 'unknown',
    '未付款': 'Unpaid',
    '部分付款': 'Partial payment',
    '未发货': 'Undelivered',
    '部分发货': 'Partial shipment',
    '已发货': 'Shipped',
    '已拒收': 'Rejected',
    '已寄票': 'Tickets posted',
    '已收票': 'Tickets received',
    '暂停': 'suspend',
    '锁定': 'locking',
    '已完成': 'Completed',
    '无退款': 'No refund',
    '部分退款': 'Partial refund',
    '全部退款': 'Full refund',
    '全部': 'all',
    '未同步到DEAR': 'Not synchronized to DEAR',
    '已同步到DEAR': 'Synchronized to DEAR',
    'DEAR中已删除': 'Deleted in DEAR',
    'DEAR同步中': 'DEAR Synchronizing',
    '新增店铺': 'New store',
    '删除店铺': 'Delete store',
    '未授权': 'Unauthorized',
    '已授权': 'Authorized',
    '已解绑': 'Unbound',
    '店铺授权到期日': 'Authorization expiration date',
    '店铺授权tip': 'After the authorization expires, just click authorize again',
    '订购链接': 'Subscription link',
    '去订购': 'To order',
    '授权链接': 'Authorization link',
    '店铺授权': 'Delegating',
    '确定要绑定吗': 'Are you sure you want to bind',
    '默认发货仓库': 'Default delivery warehouse',
    '默认退货仓库': 'Default return warehouse',
    '默认销售员': 'Default salesperson',
    '默认客户': 'Default customer',
    '默认税率': 'Default tax rate',
    '默认收款退款账户': 'Default collection/refund account',
    '订单表头字段': 'Order header field',
    '发货处理方式': 'Delivery processing method',
    '订单自动同步': 'Order Auto sync',
    '库存自动同步': 'inventory Auto sync',
    '同步所有库存': 'Synchronize all inventory',
    '自动同步订单的起始日期': 'Start date of automatic synchronization order',
    '选择日期': 'Select date',
    '服务费商品映射': 'Service charge product mapping',
    '默认销售收入科目': 'Default sales revenue account',
    '不处理': 'Do not handle',
    '从DEAR推送发货状态到平台': 'Push from DEAR',
    '从平台获取发货状态到DEAR': 'Get from platform',
    '确定要退出登录': 'Are you sure you want to log out',
    '返回首页': 'Return to the home page',
    '解绑': 'Unbind',
    '解绑店铺之后,将不能下载新的订单,是否继续': 'After unbinding the store, you will not be able to download new orders. Continue',
    '接受邀请': 'Accept the invitation',
    '请选择匹配关系': 'Please select a matching relationship',
    '存在未匹配的商品,此商品的订单下载将会收到影响,是否继续': 'There are unmatched products. The order download of this product will be affected. Continue',

    '订单日期': 'Order date',
    '执行日期': 'Execution date',
    '同步状态': 'status',
    '同步事件': 'events',
    '同步日期': 'synchronize date',
    '详细描述': 'remarks',
    '跳过': 'skip',
    '同步': 'synchronization',
    '同步中': 'Synchronizing',
    '待同步': 'To be synchronized',
    '下载平台发货信息到DEAR': 'Download platform shipment information to DEAR',
    '上传DEAR发货信息到平台': 'Upload the delivery information of dear to the platform',
    '下载订单退货': 'Download order returns',
    '作废销售订单': 'Void sales order',
    '回传平台发货信息到DEAR': 'Return the platform delivery information to DEAR',
    '订单同步': 'Order synchronization',
    '确定要执行跳过': 'Are you sure you want to skip？',
    '确定要执行同步': 'Are you sure you want to perform synchronization？',
    '平台订单号': 'Platform order number',
    '请选择要跳过的订单': 'Please select the order to skip',
    '请选择要同步的订单': 'Please select the order to synchronize',
    '请选择解绑店铺': 'Please select unbound store',
    '请选择删除店铺': 'Please select Delete store',
    '店铺解绑': 'store unbound',
    '平台tip': 'Match other non core fields of the platform order that need to be synchronized to the sales additional attribute,The matched fields can be automatically downloaded to the matched sales additional attribute fields.',
    '我的订阅': 'My Subscriptions',
    '修改密码': 'Change Password',
    '全选': 'select all',
    '全不选': 'select none',
    '步骤': 'Step ',
    '下载商品匹配列表导入模板': 'Download Our Inventory List Template File',
    '该模板文件包含了导入商品匹配数据所需要的所有字段': 'This template file contains all the fields required to import the product matching data',
    '复制商品匹配列表到模板': 'Copy item matching list to template',
    '分别从DEAR和平台中导出产品列表，将导出文件中的产品复制并粘贴到下载的模板中，确保复制的数据与模板中的列标题匹配': 'Export the product list from deal and platform respectively, copy and paste the products in the export file into the downloaded template, and ensure that the copied data matches the column header in the template',
    '为了正确导入数据，请勿修改模板文档中的列标题': 'In order to import data correctly, do not modify the column header in the template document',
    '字段说明': 'Field description',
    '字段名称': 'FIELD NAME',
    '字段解释': 'WHAT IS IT?',
    '平台商品代码': 'Platform commodity code',
    '商家用来标识商品的代码': 'Code used by merchants to identify goods',
    'DEAR商品代码': 'Dear commodity code',
    'DEAR中产品的物料代码，每个产品的物料代码是唯一的': 'The material code of the product in deal. The material code of each product is unique',
    '导入已更新的模板文件': 'Import updated template files',
    '您导入的文件': 'The file you import must be an excel file, and the name of the file must end with. XLS or. Xlsx',
    'DEAR产品代码': 'DEAR Product Code',
    '错误': 'error',
    '将文件': 'Drag files to this area, or',
    '点击上传': 'Click upload file',
    '请上传文件': 'Please upload the file',
    '商品匹配已成功导入': 'Item matching has been successfully imported',
    '输入并搜索': 'Enter and search',
    '管理员邮箱': 'Administrator mailbox',
    '是否默认tip': 'Default dead carrier when downloading platform shipment information',
    '商品全量下载': 'Full download',
    '确定要取消匹配吗': 'cancel matching ?',
    'CNY汇率': 'CNY exchange rate',
    '自动PICKPACK': 'Auto PICKPACK',
    '删除商品': 'Delete Product',
    '请选择删除商品': 'Please select the Product to delete',
    '自动PICKPACKSHIP': 'Auto PICKPACKSHIP'
  }
}